// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1domz","content":"RecentSearches_content__1xab7"};